<bn-loading-overlay></bn-loading-overlay>

<h5>Janelas de Solicitações de Honra</h5>
<div class="container">
  <div class="mb-3 row">
    <div class="col">
      <h3>Filtros de pesquisa</h3>
    </div>     
    <div class="col-auto">
      <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
    </div>
    <div class="col-auto">
      <button #focusableSubmit type="button" class="btn btn-success no-margin" (click)="buscar(true)" (keydown.enter)="buscar(true)">Pesquisar</button>
    </div>
  </div>

  <form #formPesquisa="ngForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
      <div class="col-3">
        <label class="form-label">Id da janela:</label>
        <input type="text" class="form-control" bnMask="INTEIRO" [(ngModel)]="idJanela" name="idJanela">
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label">Janela de envio: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Nome da janela de envio em formato Mês/Ano (MM/AAAA)"></i></label>
        <input type="text" class="form-control" bnMask="MESANO" [(ngModel)]="dataJanela" name="nomeJanela">
      </div>
    </div>
  </form>

  @if (pesquisado) {
    <app-janela-solicitacao-honra-listagem 
      [janelas]="janelasPaginadas" 
      [atributosPaginacao]="atributosPaginacao" 
      [opcoesPaginacao]="opcoesPaginacao"
      [dataSistema]="dataSistema"
      (aoMudarPagina)="mudarPaginacao($event)"
      (aoPedirExtensao)="abrirModal($event)"
    ></app-janela-solicitacao-honra-listagem> 
  }
</div>

<ng-template #modal>
  <form>
    <div class=" col-md-6">
      <label class="form-label">Data de fechamento: </label>
      <bn-datepicker name="dataExtensao" [(ngModel)]="dataExtensao" required 
        [minDate]="dataMinima" [maxDate]="dataMaxima"  #campoData="ngModel"
      ></bn-datepicker>
    </div>

    @if (campoData.value && !dataValida) {
      <div class="text-danger mensagem-erro">
          {{ mensagemCampoInvalido }}
      </div>  
    } 
  </form>
</ng-template>

<ng-template #botoes >
    <button class="btn btn-default" (click)="cancelarExtensao()">Cancelar</button>
    <button class="btn btn-primary" (click)="confirmarExtensao()" [disabled]="!dataValida">Confirmar</button>
</ng-template>